import React from "react";

import { formatBrazilianCurrency } from "shared/utils/formatBrazilianCurrency";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";

import FinalPricesCreditCard from "./FinalPriceCreditCard";
import FinalPricesPixBoleto from "./FinalPricePixBoleto";
import { PriceContainer, Strong } from "./styles";

const FinalPricesOrderBump = ({ textForInstallmentAmountVisualization }) => {
  const { state } = useGlobalContext();

  const { steps, offer, methodPaymentSelected } =
    useCheckoutStepsOffersContext();

  if (steps === 0)
    return (
      <PriceContainer>
        <Strong>Total</Strong>

        <Strong>
          {offer?.offer?.details?.amount_visualization === "full" ||
          !offer?.offer?.details?.payment_methods?.credit_card
            ? formatBrazilianCurrency(Number(offer?.offer?.price))
            : textForInstallmentAmountVisualization}
        </Strong>
      </PriceContainer>
    );

  return methodPaymentSelected === "boleto" ||
    methodPaymentSelected === "pix" ? (
    <FinalPricesPixBoleto />
  ) : (
    <FinalPricesCreditCard />
  );
};

export default FinalPricesOrderBump;
